/**
 * Route-level permission gate — mirrors the backend's own
 * `requirePermission`'s ALL-of semantics exactly (STEP 10's own
 * client-side engine, `core/permissions`). Always nested INSIDE
 * `ProtectedRoute`. Redirecting the whole route to `/403` here is a
 * UX courtesy only — if a user somehow reaches the underlying API
 * call anyway, the real backend `requirePermission` middleware is
 * what actually blocks it.
 */
import type { JSX } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@store/auth.store';

export interface PermissionRouteProps {
  requires: string[];
}

export function PermissionRoute({ requires }: PermissionRouteProps): JSX.Element {
  const permissions = useAuthStore((state) => state.permissions);
  const allowed = requires.every((permission) => permissions.includes(permission));

  if (!allowed) {
    return <Navigate to="/403" replace />;
  }

  return <Outlet />;
}
